import Conf, {Schema} from 'conf'

export {Conf, Schema}
